<template>
  <div class="check-status-by-sales-check-form small-padding-top-s medium-padding-top-m">
    <div class="grid-container full">
      <div class="grid-x">
        <div class="small-12 medium-5">
          <p class="small gray-1-color">
            {{ ORDER_LOOKUP.requiredField }}
          </p>
          <Form v-slot="{ meta, errors }" @submit="onSubmit">
            <div class="input-container">
              <!-- Sales Check Number -->
              <div id="sales-check-number">
                <div class="input-container">
                  <Field
                    id="salesCheckNumber"
                    v-model="salesCheckNumber"
                    type="text"
                    name="salesCheckNumber"
                    placeholder=" "
                    maxlength="8"
                    :class="{ 'is-invalid-input': !!errors['salesCheckNumber'] }"
                    :rules="salesCheckNumberRule"
                  />
                  <label class="label-top" for="salesCheckNumber"> {{ ORDER_LOOKUP.checkStatusForm.salesCheckNumberLabel }}* </label>
                </div>
                <ErrorMessage name="salesCheckNumber" class="form-error is-visible" />
              </div>
            </div>
            <InputText v-model="phoneNumber" name="phoneNumber" label="Phone Number*" rule="phone" mask="phoneFormat" />
            <PrivacyPractices class="small-12 margin-top-s" />
            <button
              name="checkStatusBtn"
              type="submit"
              :disabled="!meta.valid || !isValidSalesCheckNumber"
              class="primary button expanded small-margin-top-xs medium-margin-top-s"
            >
              {{ ORDER_LOOKUP.checkStatusForm.checkStatusLabel }}
            </button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { useFurnitureStore } from '@/stores/ppe/useFurnitureStore';
import InputText from '@atomic-ui/inputText/InputText';
import { veevalidate } from '@vue-util/forms';
import { fireTag } from '@vue-util/tagManager';
import PrivacyPractices from '@/components/common/PrivacyPractices';
import { ORDER_LOOKUP, PPE_ERROR_TAG } from 'config';

const { Form, Field, ErrorMessage } = veevalidate;

const envPropsStore = useEnvPropsStore();
const furnitureStore = useFurnitureStore();
const salesCheckNumber = ref('');
const isValidSalesCheckNumber = ref(false);
const phoneNumber = ref('');

const isMew = computed(() => envPropsStore.envProps.isMew);
const updateFurnitureApiError = computed(() => furnitureStore.updateFurnitureApiError);
const getFurnitureStatus = (payload) => furnitureStore.GET_FURNITURE_STATUS(payload, envPropsStore.envProps);

const salesCheckNumberRule = () => {
  const isValid = /^\d+$/.test(salesCheckNumber.value);
  isValidSalesCheckNumber.value = isValid;
  return isValid || ORDER_LOOKUP.checkStatusForm.salesCheckNumberErrMsg;
};

const onSubmit = async (values) => {
  const paddedSalesCheckNumber = String(values.salesCheckNumber).padStart(8, '0');
  const payloadObj = {
    salesCheckNumber: paddedSalesCheckNumber,
    salesPhoneNumber: values.phoneNumber,
    requestType: 'TICKET_PHONE_NUMBER',
    firstName: '',
    lastName: '',
    phoneNumber: '',
  };
  await getFurnitureStatus({ payloadObj, envProp: { isMew: isMew.value } });
  if (updateFurnitureApiError.value) {
    const { errorCode = PPE_ERROR_TAG.defaultErrorCode, message = '' } = updateFurnitureApiError.value;
    fireTag('link', {
      ...PPE_ERROR_TAG.error,
      error_code: [errorCode],
      error_message: [message],
    });
  }
};
</script>
